import React, { useState, useEffect, useRef } from "react";
import {
  TableContainer,
  Paper,
  Button,
  IconButton,
  Toolbar,
  Typography,
  Box,
  Menu,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  PaginationItem,
  Drawer,
  Alert,
  Snackbar,
  DialogTitle,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import FilterListIcon from "@mui/icons-material/FilterList";
import AddIcon from "@mui/icons-material/Add";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import AddEquipment from "./AddEquipmet";
import UserDateFilter from "../../../Roles and Permissions/Filters/UserFilters/UserDateFilter";
import { api, del, get } from "../../../../../utils/api";
import FilterSidebar from "../../../../../Components/Masters/Filter/FilterSidebar";
import UnitFilter from "../../HeatMaster/EquipmentMaster/Filters/unitFilter";
import ApplyButton from "../../../Roles and Permissions/Filters/ApplyButton";
import CountryFilter from "../../../Roles and Permissions/Filters/UserFilters/CountryFilter";
import BrandFilter from "../../../Roles and Permissions/Filters/BrandFilter";
import ModelFilter from "../../HeatMaster/EquipmentMaster/Filters/modelFilter";
import PaginationBox from "../../../../../Components/Masters/Pagination";
import NoDataFound from "../../../../../Components/Masters/NoDataFound";
import ResetButton from "../../../Roles and Permissions/Filters/ResetButton";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { styled } from "@mui/material/styles";
import ViewEquipment from "./ViewEquipment";
import RatedConsumptionFilter from "../../HeatMaster/EquipmentMaster/Filters/ratedConsumptionFilter";
import MainDashboardLayout from "../../../../../Layout/MainDashboardLayout";
import MastersSidebar from "../../../../../Layout/MastersSidebar";
import Unauthorized from "../../../../../Components/Unauthorized/Unauthorized";
import { useUser } from "../../../../../context/AuthContext";
import TopMenu from "../../../../../Components/Masters/TopMenu";

const ElectricityEquipment = () => {
  const { user } = useUser();

  const [equipments, setEquipments] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedEquipment, setSelectedEquipment] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [addEquipment, setAddEquipment] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({
    Date: false,
    Country: false,
    Brand: false,
    Model: false,
    Unit: false,
    RatedConsumption: false,
  });

  const [viewEquipment, setViewEquipment] = useState(false);
  const [dataView, setdataView] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [limit] = useState(10); // Number of items per page
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [selectedCountries, setSelectedCountries] = useState([]); // Store selected countries
  const [selectedEqupments, setSelectedEquipments] = useState([]);
  const [selectedModels, setSelectedModels] = useState([]);
  const [selectedUnits, setSelectedUnits] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [tempFilter, setTempFilter] = useState({
    startDate: null,
    endDate: null,
    selectedCountries: [],
    selectedEqupments: [],
    selectedModels: [],
    selectedUnits: [],
    maxConsumption: "",
    minConsumption: "",
  });
  const [errors, setErrors] = useState({
    Date: false,
    Brand: false,
    Country: false,
    Model: false,
    Unit: false,
    RatedConsumption: false,
  });
  const [ratedConsumptionRange, setRatedConsumptionRange] = useState({
    min: "",
    max: "",
  });
  const [minConsumption, setMinConsumption] = useState("");
  const [maxConsumption, setMaxConsumption] = useState("");

  const filters = ["Date", "Brand", "Model", "Unit", "Rated Consumption"];
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const tableContainerRef = useRef(null); // Reference to the table container
  const [isShortContent, setIsShortContent] = useState(false);

  const facilityData = [
    { header: "Date", field: "createdAt" },

    { header: "Brand", field: "brand" },

    { header: "Country", field: "country" },
    // { header: "Action" },
  ];

  useEffect(() => {
    const container = tableContainerRef.current;

    if (container) {
      const tableHeight = container.scrollHeight;
      const screenHeight = window.innerHeight;

      // If table content is less than half the screen height, set pagination to be at the bottom
      setIsShortContent(tableHeight < screenHeight / 1.5);
    }
  }, [equipments]);

  // Function to render the selected filter component based on user's choice
  const renderSelectedFilter = () => {
    switch (selectedFilter) {
      case "Date":
        return (
          <UserDateFilter
            startDate={tempFilter.startDate}
            endDate={tempFilter.endDate}
            setStartDate={(date) =>
              setTempFilter((prev) => ({ ...prev, startDate: date }))
            }
            setEndDate={(date) =>
              setTempFilter((prev) => ({ ...prev, endDate: date }))
            }
            errors={errors.Date}
          />
        );
      case "Brand":
        return (
          <BrandFilter
            url={`${api}/master/Electricity/getEquipment`}
            selectedEqupments={tempFilter?.selectedEqupments}
            setSelectedEquipments={(equipments) =>
              setTempFilter((prev) => ({
                ...prev,
                selectedEqupments: equipments,
              }))
            }
          />
        );

      case "Model":
        return (
          <ModelFilter
            url={`${api}/master/Electricity/getEquipment`}
            selectedModels={tempFilter?.selectedModels}
            setSelectedModels={(models) =>
              setTempFilter((prev) => ({
                ...prev,
                selectedModels: models,
              }))
            }
          />
        );
      case "Unit":
        return (
          <UnitFilter
            url={`${api}/master/Electricity/getEquipment`}
            selectedUnits={tempFilter?.selectedUnits}
            setSelectedUnits={(units) =>
              setTempFilter((prev) => ({
                ...prev,
                selectedUnits: units,
              }))
            }
          />
        );
      case "Rated Consumption":
        return (
          <RatedConsumptionFilter
            // minConsumption={tempFilter.minConsumption}
            // maxConsumption={tempFilter.maxConsumption}
            // setMinConsumption={setMinConsumption}
            // setMaxConsumption={setMaxConsumption}
            minConsumption={tempFilter.minConsumption}
            maxConsumption={tempFilter.maxConsumption}
            setMinConsumption={(value) =>
              setTempFilter((prev) => ({
                ...prev,
                minConsumption: value,
              }))
            }
            setMaxConsumption={(value) =>
              setTempFilter((prev) => ({
                ...prev,
                maxConsumption: value,
              }))
            }
            errors={errors.RatedConsumption}
          />
        );

      case "Country":
        return (
          <CountryFilter
            url={`${api}/master/Steam/Equipement`}
            // selectedCountries={selectedCountries}
            // setSelectedCountries={setSelectedCountries}
            selectedCountries={tempFilter?.selectedCountries}
            setSelectedCountries={(countries) =>
              setTempFilter((prev) => ({
                ...prev,
                selectedCountries: countries,
              }))
            }
          />
        );
      default:
        return null;
    }
  };
  const handleMenuClick = (event, equipment) => {
    setAnchorEl(event.currentTarget);
    setSelectedEquipment(equipment);
    setdataView(equipment);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedEquipment(null);
  };

  const handleEdit = () => {
    console.log("Edit equipment:", selectedEquipment);
    handleMenuClose();
    setAddEquipment(true);
    setViewEquipment(false);
  };

  const handleView = () => {
    console.log("View equipment:", selectedEquipment);
    handleMenuClose();
    setViewEquipment(true);
  };

  const handleDelete = () => {
    console.log("Delete:", selectedEquipment);
    handleMenuClose();
    setDeleteDialog(true);
  };

  const handleDeleteAggree = () => {
    del(`/master/Electricity/DeleteEquipment?Id=${dataView._id}`)
      .then((res) => {
        console.log(res, "res++");
        setDeleteDialog(false);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        setEquipments(
          equipments.filter((item) => item._id !== res.data.data._id)
        );

        // Fetch the next page's machinery data if necessary
        if (equipments.length === 1 && page > 1) {
          setPage(page - 1);
        } else {
          fetchHeatEquipment();
        }
        //   setAnchorEl(null);

        //   setSelectedUserIndex(null);
      })
      .catch((err) => {
        console.log(err, "errOfEquipment");
        setsnackOpen({
          open: true,
          message: err?.response.data.message ?? "network Error",
          severity: "error",
        });
      });
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // fetching  data
  //   const fetchHeatEquipment = async (filters = filtersToApply) => {
  const fetchHeatEquipment = async (
    filters = isFiltersApplied ? filtersToApply : {}
  ) => {
    console.log(12345, isFiltersApplied);
    try {
      console.log(sortConfig);
      const queryParams = new URLSearchParams({
        ...filters,
        minConsumption: filters.minConsumption || "", // Handle empty values
        maxConsumption: filters.maxConsumption || "",
        page, // Add the current page
        limit: rowsPerPage, // Add the number of rows per page
        sortField: sortConfig.key, // Sort configuration
        sortOrder: sortConfig.direction,
      }).toString();
      const response = await get(
        `/master/Electricity/getEquipment?${queryParams}`
      );

      console.log("1234", response.data); // Debugging line
      setEquipments(response.data.data); // Update the user list
      setTotalPages(response.data.totalPages); // Update total pages for pagination
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchHeatEquipment();
  }, [page, rowsPerPage, sortConfig, ratedConsumptionRange]);

  // default filters to apply
  const filtersToApply = {
    country: tempFilter?.selectedCountries?.join(","),
    // equipmentType: tempFilter?.equipmentType?.join(",") || [],
    brand: tempFilter?.selectedEqupments?.join(",") || [],
    model: tempFilter?.selectedModels?.join(",") || [],
    unit: tempFilter?.selectedUnits?.join(",") || [],
    startDate: tempFilter?.startDate
      ? tempFilter?.startDate.format("YYYY-MM-DD")
      : "",
    endDate: tempFilter?.endDate
      ? tempFilter?.endDate.format("YYYY-MM-DD")
      : "",
    minConsumption: tempFilter?.minConsumption || null,
    maxConsumption: tempFilter?.maxConsumption || null,
  };

  // function to validate filters
  const validateFilters = () => {
    let isValid = true;
    const newErrors = { Date: "", Facility: "", Country: "" };
    if (selectedFilter === "Date") {
      if (startDate > endDate) {
        console.log(startDate, endDate, Date.now());
        newErrors.Date = "End date must be greater than Start date";
        isValid = false;
      }
    }

    if (selectedFilter === "Rated Consumption") {
      const min = parseFloat(tempFilter.minConsumption);
      const max = parseFloat(tempFilter.maxConsumption);

      // Check if both values are provided
      if (
        tempFilter.minConsumption !== "" &&
        tempFilter.maxConsumption !== ""
      ) {
        if (isNaN(min) || isNaN(max)) {
          newErrors.RatedConsumption = "Both values must be valid numbers";
          isValid = false;
        } else if (min > max) {
          newErrors.RatedConsumption =
            "Min consumption cannot be greater than max consumption";
          isValid = false;
        }
      }
      // Check if individual values are valid when only one is provided
      else if (tempFilter.minConsumption !== "" && isNaN(min)) {
        newErrors.RatedConsumption = "Min consumption must be a valid number";
        isValid = false;
      } else if (tempFilter.maxConsumption !== "" && isNaN(max)) {
        newErrors.RatedConsumption = "Max consumption must be a valid number";
        isValid = false;
      }
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleApplyFilters = () => {
    // Validate filters before applying
    if (!validateFilters()) return;
    // setPage(1);
    // // Prepare the filters for RatedConsumption, add to other filters

    const consumptionFilter = {
      minConsumption: tempFilter.minConsumption || null,
      maxConsumption: tempFilter.maxConsumption || null,
    };

    // fetchHeatEquipment();
    setDrawerFilterOpen(false);
    handleAppliedFilters();
    setSelectedCountries(tempFilter?.selectedCountries);
    setSelectedEquipments(tempFilter?.selectedEqupments);
    setSelectedModels(tempFilter?.selectedModels);
    setStartDate(tempFilter?.startDate);
    setEndDate(tempFilter?.endDate);
    setMinConsumption(tempFilter.minConsumption);
    setMaxConsumption(tempFilter.maxConsumption);
    setSelectedUnits(tempFilter?.selectedUnits);
    fetchHeatEquipment({
      ...filtersToApply,
      ...consumptionFilter,
    });
    setPage(1);
  };

  const handleResetFilters = () => {
    setStartDate(null);
    setEndDate(null);
    setSelectedCountries([]);
    setSelectedEquipments([]);
    setSelectedModels([]);
    setSelectedUnits([]);
    setTempFilter({
      selectedCountries: [],
      selectedEqupments: [],
      selectedModels: [],
      selectedUnits: [],
      startDate: null,
      endDate: null,
    });
    // setRatedConsumptionRange([]);
    setRatedConsumptionRange({ min: "", max: "" });
    setMinConsumption("");
    setMaxConsumption("");
    setAppliedFilters({});
    setIsFiltersApplied(false);
    fetchHeatEquipment({});
    setErrors({});
    setDrawerFilterOpen(false);
  };

  const handleAppliedFilters = () => {
    const isDateApplied =
      tempFilter?.startDate || tempFilter?.endDate ? true : false;
    const isCountryApplied = tempFilter?.selectedCountries.length > 0;
    const isBrandApplied = tempFilter?.selectedEqupments.length > 0;
    const isModelApplied = tempFilter?.selectedModels.length > 0;
    const isUnitApplied = tempFilter?.selectedUnits.length > 0;
    const isRatedConsumptionFilter =
      tempFilter?.minConsumption || tempFilter?.maxConsumption ? true : false;

    setIsFiltersApplied(
      isDateApplied ||
        isCountryApplied ||
        isBrandApplied ||
        isModelApplied ||
        isUnitApplied ||
        isRatedConsumptionFilter
    );

    setAppliedFilters((prevAppliedFilters) => ({
      ...prevAppliedFilters,
      Date: isDateApplied,
      Country: isCountryApplied,
      Brand: isBrandApplied,
      Model: isModelApplied,
      Unit: isUnitApplied,
      RatedConsumptionFilter: isRatedConsumptionFilter,
    }));
  };

  // Handle Sorting function
  const handleSort = (column, direction) => {
    setSortConfig({ key: column, direction });
  };

  const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
    "&.Mui-selected": {
      backgroundColor: "green",
      color: "#fff",
      fontWeight: "bold",
    },
    "&:hover": {
      backgroundColor: "#ededed",
    },
  }));

  const handleFilterDrawer = () => {
    setTempFilter({
      startDate: startDate,
      endDate: endDate,
      selectedCountries: selectedCountries,
      selectedEqupments: selectedEqupments,
      selectedModels: selectedModels,
      selectedUnits: selectedUnits,
      minConsumption: minConsumption,
      maxConsumption: maxConsumption,
    });
    setDrawerFilterOpen(false);
    setErrors({ Date: false, Role: false });
  };

  return (
    <MainDashboardLayout sidebar={<MastersSidebar />}>
      <Unauthorized requiredModule="Setup | Master">
        <Box
          sx={{
            backgroundColor: "#ededed",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Snackbar
            open={snackOpen.open}
            autoHideDuration={3000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={() => setsnackOpen({ ...snackOpen, open: false })}
          >
            <Alert
              // onClose={handleClose}
              severity={snackOpen.severity}
              variant="filled"
              sx={{ width: "100%" }}
            >
              {snackOpen.message}
              {/* Add user Successfully */}
            </Alert>
          </Snackbar>
          <AddEquipment
            addEquipment={addEquipment}
            setAddEquipment={setAddEquipment}
            fetchHeatEquipment={fetchHeatEquipment}
            setsnackOpen={setsnackOpen}
            //  addFacility={addFacility}
            selectedEquipment={dataView}
          />
          <ViewEquipment
            viewEquipment={viewEquipment}
            setViewEquipment={setViewEquipment}
            selectedEquipment={dataView}
            handleEdit={handleEdit}
          />
          {deleteDialog && (
            <Dialog open={deleteDialog}>
              <DialogTitle>Confirm Delete</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Do you really want to delete this entry?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setDeleteDialog(false)} color="primary">
                  Cancel
                </Button>
                <Button onClick={handleDeleteAggree} color="secondary">
                  Confirm
                </Button>
              </DialogActions>
            </Dialog>
          )}
          {/* <Toolbar> */}
          {drawerFilterOpen && (
            <Drawer
              anchor="right"
              open={drawerFilterOpen}
              onClose={() => handleFilterDrawer()}
              sx={{
                backgroundColor: "transparent",
                "& .MuiDrawer-paper": {
                  // This targets the paper component within the Drawer
                  backgroundColor: "transparent", // Make paper transparent
                  boxShadow: "none", // Optional: Remove any shadow
                  width: "50%",
                },
              }}
            >
              <Box
                display="flex"
                gap={3}
                sx={{
                  width: "100%",
                  display: "flex",
                  overflowX: "hidden",
                  maxWidth: "100%",
                  justifyContent: "space-btween",
                  height: "100%",
                  backgroundColor: "transparent",
                }}
              >
                <Box
                  sx={{
                    backgroundColor: "#f5f5f5",
                    height: "3%",
                    padding: "13px",
                    margin: "30px 0 0 0",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "80%",
                    width: "3%",
                  }}
                >
                  <IconButton
                    // onClick={() => setDrawerFilterOpen(false)}
                    onClick={() => handleFilterDrawer()}
                    sx={{ color: "black" }}
                  >
                    <CloseIcon sx={{ fontSize: "1.2rem" }} />
                  </IconButton>
                </Box>
                <Box sx={{ display: "flex", width: "100%", height: "100vh" }}>
                  {/* Sidebar for selecting the filter */}
                  <FilterSidebar
                    {...{
                      setSelectedFilter,
                      selectedFilter,
                      filters,
                      appliedFilters,
                    }}
                  />

                  {/* Filter content area */}
                  <Box
                    sx={{
                      flexGrow: 1,
                      backgroundColor: "#F9F9F9",
                      padding: "20px",
                    }}
                  >
                    {renderSelectedFilter()}
                    <Box
                      sx={{
                        display: "flex",
                        width: "100%",
                        gap: "3%",
                        position: "fixed",
                        bottom: "20px",
                        ml: 3,
                        mr: 3,
                      }}
                    >
                      <ApplyButton handleApply={handleApplyFilters} />
                      <ResetButton handleReset={handleResetFilters} />
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Drawer>
          )}{" "}
          {/* <Box
            sx={{
              pt: "2rem",
              // display: "flex",
              justifyContent: "space-between",
              width: !user?.companyAdmin ? "96%" : "100%",
              // marginRight: "1.5%",
              // justifyContent: "flex-end",
              // ml: "20%",
            }}
          >
            <Box item xs={6} sx={{ paddingLeft: 0, display: "flex" }}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "bold",
                  textDecoration: "underline",
                  paddingLeft: "2.5%",
                  marginLeft: "-2.6%",
                }}
              >
                {"Scope 2"}
              </Typography>
            </Box>
            <Box
              sx={{
                textAlign: "right",
                margin: "1rem 0",
                // border: "1px solid red",
              }}
            >
              <Button
                variant="contained"
                // onClick={() => setDrawerFilterOpen(true)}
                onClick={() => {
                  setTempFilter({
                    startDate: startDate,
                    endDate: endDate,
                    selectedCountries: selectedCountries,
                    selectedUnits: selectedUnits,
                    maxConsumption: maxConsumption,
                    minConsumption: minConsumption,
                    selectedModels: selectedModels,
                    selectedEqupments: selectedEqupments,
                  });
                  setDrawerFilterOpen(true);
                }}
                sx={{
                  // margin: "0px 10px 5px 0px",
                  margin: !user?.companyAdmin ? "0px 10px 5px 0px" : "0px",
                  backgroundColor: "#ffffff",
                  color: "black",
                  "&:hover": { backgroundColor: "#1c486b", color: "#FFFFFF" },
                  "&:hover .dot-icon": {
                    color: "#FFFFFF", // Change dot color on button hover
                  },
                  // display:"flex"
                }}
              >
                Filter
                <FilterListIcon />
                {(tempFilter?.selectedCountries.length > 0 ||
                  tempFilter?.selectedEqupments.length > 0 ||
                  tempFilter?.selectedUnits.length > 0 ||
                  tempFilter?.selectedModels.length > 0 ||
                  tempFilter?.maxConsumption ||
                  tempFilter?.minConsumption ||
                  tempFilter?.startDate ||
                  tempFilter?.endDate) && (
                  <FiberManualRecordIcon
                    className="dot-icon"
                    sx={{
                      fontSize: "10px",
                      color: "#488257",
                      marginLeft: "5px",
                    }}
                  />
                )}
              </Button>
              {!user?.companyAdmin && (
                <Button
                  variant="contained"
                  endIcon={<AddIcon />}
                  sx={{
                    margin: "0px -36px 5px 0px",
                    backgroundColor: "#1c486b",
                    fontSize: "14px",
                    textTransform: "none",
                  }}
                  onClick={() => {
                    setAddEquipment(true);
                    setdataView(null);
                  }}
                >
                  Add New
                </Button>
              )}
            </Box>
          </Box> */}
          <TopMenu
            setData={setdataView}
            setAddData={setAddEquipment}
            onClick={() => {
              setTempFilter({
                startDate: startDate,
                endDate: endDate,
                selectedCountries: selectedCountries,
                selectedUnits: selectedUnits,
                maxConsumption: maxConsumption,
                minConsumption: minConsumption,
                selectedModels: selectedModels,
                selectedEqupments: selectedEqupments,
              });
              setDrawerFilterOpen(true);
            }}
            {...{
              heading: "Scope 2",
              setDrawerFilterOpen,
              filterApplied:
                tempFilter?.selectedCountries.length > 0 ||
                tempFilter?.selectedEqupments.length > 0 ||
                tempFilter?.selectedUnits.length > 0 ||
                tempFilter?.selectedModels.length > 0 ||
                tempFilter?.maxConsumption ||
                tempFilter?.minConsumption ||
                tempFilter?.startDate ||
                tempFilter?.endDate,
            }}
          />
          {/* </Toolbar> */}
          <TableContainer
            component={Paper}
            ref={tableContainerRef}
            sx={{ flex: 1, overflow: "hidden" }}
          >
            <Box>
              <Box sx={{ margin: "16px" }}>
                <Box
                  sx={{
                    fontWeight: "bold",
                    fontSize: "20px",
                    textAlign: "left",
                    display: "flex",
                    flexDirection: "column",
                    // padding: "0px",
                  }}
                >
                  Electricity Equipment Master
                </Box>
              </Box>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "12% 20% 13% 13% 21% 12% 9%",
                  borderBottom: "1px solid #ddd",
                  borderTop: "1px solid #ddd",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 16px",
                    textAlign: "left",
                    borderRight: "1px solid #ddd",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  Date
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "2px",
                      marginLeft: "10px",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => handleSort("createdAt", "asc")}
                    >
                      <ExpandLess
                        sx={{
                          color:
                            sortConfig.key === "createdAt" &&
                            sortConfig.direction === "asc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleSort("createdAt", "desc")}
                    >
                      <ExpandMore
                        sx={{
                          color:
                            sortConfig.key === "createdAt" &&
                            sortConfig.direction === "desc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                  </Box>
                </Typography>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    textAlign: "left",
                    borderRight: "1px solid #ddd",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  Equipment Name
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "2px",
                      marginLeft: "10px",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => handleSort("equipment", "asc")}
                    >
                      <ExpandLess
                        sx={{
                          color:
                            sortConfig.key === "equipment" &&
                            sortConfig.direction === "asc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleSort("equipment", "desc")}
                    >
                      <ExpandMore
                        sx={{
                          color:
                            sortConfig.key === "equipment" &&
                            sortConfig.direction === "desc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                  </Box>
                </Typography>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    textAlign: "left",
                    borderRight: "1px solid #ddd",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  Brand
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "2px",
                      marginLeft: "10px",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => handleSort("brand", "asc")}
                    >
                      <ExpandLess
                        sx={{
                          color:
                            sortConfig.key === "brand" &&
                            sortConfig.direction === "asc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleSort("brand", "desc")}
                    >
                      <ExpandMore
                        sx={{
                          color:
                            sortConfig.key === "brand" &&
                            sortConfig.direction === "desc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                  </Box>
                </Typography>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    textAlign: "left",
                    borderRight: "1px solid #ddd",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  Model
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "2px",
                      marginLeft: "10px",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => handleSort("model", "asc")}
                    >
                      <ExpandLess
                        sx={{
                          color:
                            sortConfig.key === "model" &&
                            sortConfig.direction === "asc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleSort("model", "desc")}
                    >
                      <ExpandMore
                        sx={{
                          color:
                            sortConfig.key === "model" &&
                            sortConfig.direction === "desc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                  </Box>
                </Typography>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    textAlign: "left",
                    borderRight: "1px solid #ddd",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  Rated Consumption / Hour
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "2px",
                      marginLeft: "10px",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => handleSort("ratedConsumption", "asc")}
                    >
                      <ExpandLess
                        sx={{
                          color:
                            sortConfig.key === "ratedConsumption" &&
                            sortConfig.direction === "asc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleSort("ratedConsumption", "desc")}
                    >
                      <ExpandMore
                        sx={{
                          color:
                            sortConfig.key === "ratedConsumption" &&
                            sortConfig.direction === "desc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                          color: "black",
                        }}
                      />
                    </IconButton>
                  </Box>
                </Typography>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    textAlign: "left",
                    borderRight: "1px solid #ddd",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  Unit
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "2px",
                      marginLeft: "10px",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => handleSort("unit", "asc")}
                    >
                      <ExpandLess
                        sx={{
                          color:
                            sortConfig.key === "unit" &&
                            sortConfig.direction === "asc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleSort("unit", "desc")}
                    >
                      <ExpandMore
                        sx={{
                          color:
                            sortConfig.key === "unit" &&
                            sortConfig.direction === "desc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                  </Box>
                </Typography>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px 8px 16px",
                    textAlign: "left",
                    // borderRight: "1px solid #ddd",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                  }}
                >
                  Action
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "2px",
                      marginLeft: "10px",
                    }}
                  ></Box>
                </Typography>
              </Box>
              {equipments.length === 0 ? (
                <NoDataFound />
              ) : (
                equipments.map((equipments) => (
                  <Box
                    key={equipments._id}
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "12% 20% 13% 13% 21% 12% 9%",
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    <Typography
                      sx={{
                        padding: "8px 16px",
                        textAlign: "left",
                        borderRight: "1px solid #ddd",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: "14px",
                        color: "black",
                      }}
                    >
                      {/* {new Date(equipments.createdAt).toLocaleDateString()} */}
                      {new Date(equipments.createdAt).toLocaleDateString(
                        "en-GB",
                        {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        }
                      )}
                    </Typography>
                    <Typography
                      sx={{
                        padding: "8px 12px",
                        textAlign: "left",
                        borderRight: "1px solid #ddd",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: "14px",
                        color: "black",
                      }}
                    >
                      {equipments.equipment}
                    </Typography>
                    <Typography
                      sx={{
                        padding: "8px 12px",
                        textAlign: "left",
                        borderRight: "1px solid #ddd",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: "14px",
                        color: "black",
                      }}
                    >
                      {equipments.brand}
                    </Typography>
                    <Typography
                      sx={{
                        padding: "8px 12px",
                        textAlign: "left",
                        borderRight: "1px solid #ddd",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: "14px",
                        color: "black",
                      }}
                    >
                      {equipments.model}
                    </Typography>
                    <Typography
                      sx={{
                        padding: "8px 12px",
                        textAlign: "left",
                        borderRight: "1px solid #ddd",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: "14px",
                        color: "black",
                      }}
                    >
                      {equipments.ratedConsumption}
                    </Typography>
                    <Typography
                      sx={{
                        padding: "8px 12px",
                        textAlign: "left",
                        borderRight: "1px solid #ddd",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: "14px",
                        color: "black",
                      }}
                    >
                      {equipments.unit}
                    </Typography>
                    <Box
                      sx={{
                        padding: "1px",
                        textAlign: "center",
                      }}
                    >
                      <IconButton
                        onClick={(e) => handleMenuClick(e, equipments)}
                      >
                        <MoreHorizIcon
                          sx={{ fontWeight: "bold", color: "black" }}
                        />
                      </IconButton>
                    </Box>
                  </Box>
                ))
              )}
            </Box>
          </TableContainer>
          {/* </TableContainer> */}
          {/* Pagination */}
          {totalPages > 1 && (
            <PaginationBox
              totalPages={totalPages}
              page={page}
              handleChangePage={handleChangePage}
              StyledPaginationItem={StyledPaginationItem}
              isShortContent={isShortContent} // Pass this state to PaginationBox
            />
          )}
          {/* Menu for Actions */}
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            PaperProps={{
              sx: {
                width: "120px",
                border: "1px solid #ddd",
                marginLeft: "-47px",
              },
            }}
          >
            {user?.companyAdmin ? (
              <>
                <MenuItem onClick={handleView} sx={{ fontSize: "14px" }}>
                  <AssignmentIcon
                    sx={{ marginRight: "8px", fontSize: "large" }}
                  />
                  View Logs
                </MenuItem>
              </>
            ) : (
              <>
                <MenuItem onClick={handleView} sx={{ fontSize: "14px" }}>
                  <AssignmentIcon
                    sx={{ marginRight: "8px", fontSize: "large" }}
                  />
                  View Logs
                </MenuItem>
                <MenuItem onClick={handleEdit} sx={{ fontSize: "14px" }}>
                  <EditIcon sx={{ marginRight: "8px", fontSize: "large" }} />{" "}
                  Edit
                </MenuItem>
                <MenuItem onClick={handleDelete} sx={{ fontSize: "14px" }}>
                  <DeleteIcon sx={{ marginRight: "8px", fontSize: "large" }} />{" "}
                  Delete
                </MenuItem>
              </>
            )}
          </Menu>
        </Box>
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default ElectricityEquipment;
